document.addEventListener('DOMContentLoaded', function () {
    window.SquaretalkMenu?.createMenuController({document: window.document});
    window.SquaretalkTOC?.initTOC({document: window.document});
});
